import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ShIconLinkComponent } from '../icon-link/icon-link.component';
import { ShIconModule } from '../icon/icon.module';
import { NavigationItem } from '../navigation-item/entities/navigation-item.entity';

@Component({
    standalone: true,
    selector: 'sh-dashboard-panel-title',
    templateUrl: './dashboard-panel-title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShIconLinkComponent, ShIconModule]
})
export class ShDashboardPanelTitleComponent {
    @Input()
    title!: string;

    @Input()
    icon!: string;

    @Input()
    navigationItem?: NavigationItem;
}
